<div *ngIf="loaded" class="native-datepicker-container">
  <input [ngClass]="{'native-datepicker-invalid' : !dateValid}" class="native-datepicker" [valueAsDate]="dateSelected"
    type="date" (change)="valueChanged($event.target.value)" />
</div>
<div *ngIf="!dateValid">
  <span class="field-validation-error xlastname">{{errorMessage}}</span>
</div>
